export type PaymentMethod = 'card' | 'wallet';

export function PaymentMethodPicker({ value, onChange, disabled }: {
  value: PaymentMethod;
  onChange: (value: PaymentMethod) => void;
  disabled: boolean;
}): React.ReactElement {
  return (
    <fieldset className="payment-methods" disabled={disabled}>
      <legend>Ödəniş üsulu</legend>
      <label><input type="radio" name="payment-method" value="card"
        checked={value === 'card'} onChange={() => onChange('card')} /> Bank kartı</label>
      <label><input type="radio" name="payment-method" value="wallet"
        checked={value === 'wallet'} onChange={() => onChange('wallet')} /> Apple Pay / Google Pay</label>
      <p className="onboard-note">{value === 'card'
        ? 'Kart nömrəsi, son istifadə tarixi və CVV Yığım səhifəsində daxil edilir.'
        : 'Ödənişi cihazınızda mövcud olan elektron pul kisəsi ilə tamamlayın.'}</p>
    </fieldset>
  );
}
